<div class="generic-after-attendee-card"
     [class.hide]='type === EventConfirmationPageCardType.SOCIAL_MEDIA && !haveSocialMediaLinks() && !isEdit'
     [class.disabled]='isEdit && isHidden'
     [class.edit-mode]='isEdit'>
  @if(isEdit){
    @if(loggedUser?.isPro()){
      <div class='visibility-icon' (click)='toggleVisible()'>
        @if(isHidden){
          <i class="fa-regular fa-eye-slash"></i>
        }@else{
          <i class="fa-regular fa-eye"></i>
        }
      </div>
    }@else if(isProSection()){
      <div class='lock-icon'
           (click)='!isDesktop && updateToProDialog()'
           [ngxTippy]="isDesktop ? tooltipProAccountTemplate : null"
           [tippyProps]="{
                interactive: true,
                placement: 'top-start'
              }">
        <i class="fa-solid fa-lock"></i>
      </div>
    }@else{
      <div class='visibility-icon' (click)='toggleVisible()'>
        @if(isHidden){
          <i class="fa-regular fa-eye-slash"></i>
        }@else{
          <i class="fa-regular fa-eye"></i>
        }
      </div>
    }
  }
  <div class="card-body">
    <div class="icon" [innerHTML]="getIcon() | safeHtml">
    </div>
    <div class="content">
      <div class="info">
        @if(isCardEditable() && isEdit){
          <app-rich-text-editor
            class="card-title"
            [valueToChange]="getTitle()"
            [disableColorChange]='true'
            (updateValue)="saveEditorContent($event, 'title')"
          />
          <app-rich-text-editor
            class="card-description"
            [valueToChange]="getDescription()"
            [disableColorChange]='true'
            (updateValue)="saveEditorContent($event, 'description')"
          />
        }@else{
          <div class="card-title" [innerHtml]='getTitle() | safeHtml'></div>
          <div class="card-description" [innerHtml]='getDescription() | safeHtml'></div>
        }
      </div>
    </div>
  </div>
  @if(type === EventConfirmationPageCardType.CREATE_ACCOUNT){
    <div class='actions-wrapper'>
      <button class="btn btn-primary-outline action-button-card" (click)="goToSignUp()">{{ "APP.EVENT_AFTER_ATTEND.GENERIC.SIGN_UP_NOW" | translate }}</button>
    </div>
  }
  @if(type === EventConfirmationPageCardType.SOCIAL_MEDIA){
    <app-edit-social-media-buttons
      [isEditMode]="isEdit"
      [event]='event'
      [biggerSize]='true'
      (click)='editSocialMedia($event)'
      class='w-100 social-media-buttons'
    />
  }
  @if(type === EventConfirmationPageCardType.CREATE_EVENT){
    <swiper-container
      appSwiper
      [config]="swiperConfig"
      init="false"
      class="templates-swiper"
    >
      @for (designTemplate of designTemplates; track designTemplate.id) {
        <swiper-slide>
          <app-design-template-card
            [template]="designTemplate"
            [size]="180"
            [noCallback]="true"
            [loggedUser]="loggedUser"
            [selectMode]='false'
          ></app-design-template-card>
        </swiper-slide>
      }
    </swiper-container>
    <div class='actions-wrapper'>
      <button class="btn btn-primary-outline action-button-card" (click)="createEvent()">{{ "APP.EVENTS.CREATE" | translate }}</button>
    </div>
  }

</div>
<ng-template #tooltipProAccountTemplate let-data="data">
  <div class="reacted-by">
    {{ "APP.EVENT_AFTER_ATTEND.GENERIC.YOU_NEED_PRO_ACCOUNT" | translate }} <span class='link-text' (click)='updateToProDialog()'>{{ "APP.EVENT_AFTER_ATTEND.GENERIC.UPGRADE_NOW" | translate }}</span>
  </div>
</ng-template>
